import { render, staticRenderFns } from "./BarWap.vue?vue&type=template&id=1ca966ad&scoped=true&"
import script from "./BarWap.vue?vue&type=script&lang=js&"
export * from "./BarWap.vue?vue&type=script&lang=js&"
import style0 from "./BarWap.vue?vue&type=style&index=0&id=1ca966ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca966ad",
  null
  
)

export default component.exports